import type { JSX } from 'react'

export const SettingsIcon = ({ filled }: { filled?: boolean }): JSX.Element => (
  <>
    <use href='#settingsIcon' height='100%' width='100%' />
    <use
      href='#settingsSolidIcon'
      height='100%'
      width='100%'
      fillOpacity={filled ? 1 : 0}
    />
  </>
)
